module.exports = __webpack_public_path__ + "img/product-ABS2.5a82dc5a.svg";